exports.Cities = { 
    MY :[
        "Ampang Jaya", 
        "Bangsar", 
        "Batu Caves", 
        "Bayan Lepas", 
        "Bukit Bintang", 
        "Cheras", 
        "Cyberjaya", 
        "George Town", 
        "Klang", 
        "Kota Kinabalu", 
        "Kuala Lumpur", 
        "Petaling Jaya", 
        "Puchong", 
        "Putrajaya", 
        "Seremban", 
        "Shah Alam"
      ],
    SG :[
        "Outram", 
        "Museum", 
        "Singapore River", 
        "Clementi", 
        "Geylang", 
        "Jurong East", 
        "Woodlands", 
        "Jurong West", 
        "Hougang", 
        "Tampines", 
        "Orchard", 
        "Rochor", 
        "River Valley", 
        "Queenstown", 
        "Newton", 
        "Marina East", 
        // "Changi"
      ],
    TH :[
        // "Jatujak", 
        // "Krung Thep Maha Nakhon", 
        // "Nonthaburi", 
        // "Samrong Nuea", 
        // "Song Khanong",
        "Bang Rak",
        // "Din Daeng",
        "Huai Khwang",
        "Pathum Wan",
        "Phaya Thai",
        "Ratchathewi",
        "Sathon",
        // "Watthana",
        "Chatuchak",
        // "Wang Thonglang",
        "Lat Phrao",
        // "Khlong Toey"
        // "Bang Sue"
      ],
    ID: [
        "South Tangerang",
        "Tangerang",
        "Gunung Sindur",
        "Parung Panjang",
        "South Jakarta",
        "West Jakarta",
        "East Jakarta",
        "Bogor",
        "Depok"
      ]
}
